import dayjs from "dayjs"
import { NumberOfPayments } from "src/features/calculator/utils/calculator"
import {
  is20230907RestartedJukyakuStores,
  is20231030RestartedJukyakuStores,
  is20210101ZeroYenCampaignContinuingJukyakuStores,
} from "src/features/calculator/utils/autoDetect/autoDetermineFormula"

// 受客再開加盟店
function isRestartedJukyakuStores(applicatedAt: dayjs.Dayjs, storeName: string): boolean {
  if (dayjs.isDayjs(applicatedAt) && applicatedAt.isAfter("2023-11-30", "days")) {
    return true
  } else if (
    dayjs.isDayjs(applicatedAt) &&
    applicatedAt.isAfter("2023-10-29", "days") &&
    is20231030RestartedJukyakuStores(storeName)
  ) {
    return true
  } else if (
    dayjs.isDayjs(applicatedAt) &&
    applicatedAt.isAfter("2023-09-06", "days") &&
    is20230907RestartedJukyakuStores(storeName)
  ) {
    return true
  }
  return false
}

export function autoDetect(
  storeName: string,
  adPrice: number,
  isRecipient: boolean,
  nop: number,
  applicatedAt: string
) {
  // MEMO(nontangent): 入力漏れがある場合はクリックを許可しない
  if (!(storeName && adPrice !== null && isRecipient !== null && applicatedAt !== null)) {
    return true
  }

  const applicatedAtDayjs = dayjs(applicatedAt)
  if (isRecipient) {
    if (!isRestartedJukyakuStores(applicatedAtDayjs, storeName)) {
      return true
    } else if (
      dayjs.isDayjs(applicatedAtDayjs) &&
      applicatedAtDayjs.isAfter("2022-12-31", "days")
    ) {
      // MEMO(nontangent): 2023円年1月1日以降の受客0円キャンペーン継続点以外は分割回数が自動判定に必要なためバリデーションで弾く。
      if (
        !is20210101ZeroYenCampaignContinuingJukyakuStores(storeName) &&
        nop === NumberOfPayments.Undecided
      )
        return true
    }
  }
  return false
}
